import { Button } from "antd";
import React from "react";
import { ShoppingCartOutlined } from "@ant-design/icons";
import "./pricecard.scss";

const PriceCard = ({
  features,
  chats,
  paymentPlan,
  price,
  handleBuyNow,
  tag,
  plan,
  isLoading = false,
  index,
  disabled,
  isFree,
  buttonText
}) => {
  const listStyles = {
    marginTop: '30px',
    width: '100%'
  };
  
  const listItemStyles = {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    justifyContent: 'flex-start'
  };
  
  return (
    <div className={`price-card ${tag ? "highlighted" : ""}`}>
      {tag && <div className="popular-tag">Most Popular</div>}

      <div className="price-card-content">
        <h3 className="plan">{plan}</h3>
        <div className="price">
          {typeof price === "number" ? `$${price}` : price}
        </div>

        <ul role="list" className="features" style={listStyles}>
          <li style={listItemStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{chats}Text chats</span>
          </li>
          <li style={listItemStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{chats}Voice chats</span>
          </li>
          <li style={listItemStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{chats}50 preset Avatar's</span>
          </li>
          <li style={listItemStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{chats}Widget Customizable</span>
          </li>
          <li style={listItemStyles}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            <span>{chats}Avatar Customizable</span>
          </li>
          {features.map((feat, i) => (
            <li key={i}>
              <span>{feat}</span>
            </li>
          ))}
        </ul>
      </div>

      <Button
        type="primary"
        size="large"
        onClick={() => !disabled && handleBuyNow(paymentPlan, index)}
        loading={isLoading}
        icon={<ShoppingCartOutlined style={{ fontSize: "22px" }} />}
        className="buy-button"
        disabled={disabled}
      >
        {buttonText}
      </Button>
    </div>
  );
};

export default PriceCard;
